import { getRequest } from '@homework-studio/api-client';
import { ClassModel, ClassPlaceModel, ClassTypeModel, FullInfoClassModel } from '@shared/types';
import { ClassStudent } from '../class-student.type';

export const classesApi = {
  getListActive: async (params: unknown) => {
    const res = await getRequest<ClassModel[]>('/classes/active', params);
    return res; // chỉ lấy data
  },
  getList: async (params: unknown) => {
    const res = await getRequest<FullInfoClassModel[]>('/classes', params);
    return res; //lấy data và totalItem
  },
  getStudentList: async (classId: number | string) => {
    const res = await getRequest<ClassStudent[]>(`/classes/${classId}/students`);
    return res.data;
  },

  getClassTypeAndPlace: async () => {
    const res = await getRequest<{
      classTypes: ClassTypeModel[];
      classPlaces: ClassPlaceModel[];
    }>('/classes/metadata');
    return res.data; // chỉ lấy data
  },
};
